// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ADxQ","footer":"styles_footer__2UwMY"};